import { Link } from "react-router-dom";
import { Button } from "../components";

export default function Forbidden() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div className="text-6xl font-bold text-black dark:text-lz-concrete">
        403
      </div>
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-black dark:text-lz-concrete">
          Forbidden
        </h1>
        <p className="mt-2 text-black dark:text-lz-concrete">
          You are not authorized to access this page.
        </p>
      </div>
      <Link to="/">
        <Button>Return Home</Button>
      </Link>
    </div>
  );
}
